var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHasCarwash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5h3v2h-3v-2zm18-4l-2-2h-15l-2 2v4h11.471m3.529-11h-11l-2 5h15zm-15 9H6",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.809 19.691a3.81 3.81 0 01-7.618 0C14.191 17.589 18 12.5 18 12.5s3.809 5.09 3.809 7.191zm-4.204 1.808a4.487 4.487 0 01-1.105-2.955",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
export default SvgHasCarwash;